// extracted by mini-css-extract-plugin
export default {"modal-body":"styles_modal-body__qGR-W"};